module.exports = __webpack_public_path__ + "media/images/el_dardo-6e8162a0dc989c40a4cca11bd3403c3d.jpg";